import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { JiraLogo } from "@atlaskit/logo";

import {
    JiraOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useUserContext } from "@/components/user-context";
import { wacToken } from "@/libraries/design/foundations";
import { experiments, ExperimentView } from "@/utils/experiment";

import { WelcomeBackHeading } from "../../components";

export const LoggedInJiraFreeExistingSitesUser = () => (
    <ExperimentView
        experiment={experiments.jfindSignUpFlowOverlay}
        render={(value) =>
            value ? (
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<JiraLogo size="xlarge" appearance="brand" />}
                >
                    <Content />
                </SignupBackgroundLayout>
            )
        }
    />
);

const Content = () => {
    const {
        user: { name }
    } = useUserContext();

    const intl = useIntl();
    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText",
        defaultMessage: "It’s free for up to 10 users - no credit card needed."
    });

    return (
        <div css={containerCss}>
            <h1 css={headerCss}>
                <WelcomeBackHeading name={name} />
            </h1>
            <p css={subHeaderCss}>{subHeaderText}</p>
            <SiteActivation />
        </div>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    margin: "0 auto",
    color: wacToken("color.primary.black"),
    textAlign: "center"
});
